import { IELTLastMeetingData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { memo } from 'react'

import { FormTextarea, useGetFormData } from 'cng-common/features/form'

import { EditableFieldsNames } from './configs'
import { EditableFieldsTranslation } from './translation'

interface IProps {
  item: IELTLastMeetingData
  formKey: string
}

export const EditableFields = memo<IProps>(({ item, formKey }) => {
  useGetFormData<IELTLastMeetingData>(formKey, item)
  return (
    <>
      <td>
        <FormTextarea
          label={EditableFieldsTranslation.Status}
          defaultValue={item.status}
          field={EditableFieldsNames.Status}
          formKey={formKey}
        />
      </td>
      <td>
        <FormTextarea
          label={EditableFieldsTranslation.Action}
          defaultValue={item.action}
          field={EditableFieldsNames.Action}
          formKey={formKey}
        />
      </td>
      <td>
        <FormTextarea
          label={EditableFieldsTranslation.Update}
          defaultValue={item.update}
          field={EditableFieldsNames.Update}
          formKey={formKey}
        />
      </td>
    </>
  )
})
